import { makeStyles } from "@mui/styles";
import { ExtraBold, SemiBold, remCalc } from "../../utils";

export const NewLineChartStyle = makeStyles((theme) => ({
    tooltipBox: {
        background: "#fff",
        borderRadius: 8,
    },
    ttTitle: {
        fontSize: remCalc(12),
        fontFamily: SemiBold,
        color: theme.typography.color.secondary
    },
    ttDot: {
        height: 8,
        width: 8,
        borderRadius: "50%"
    },
    ttValue: {
        fontSize: remCalc(14),
        fontFamily: ExtraBold,
        color: theme.typography.color.primary
    }
}))